module.exports = __webpack_public_path__ + "img/5.3216fb1f.jpg";